<template>
  <div style="background-color: white; min-height: 100vh">
    <Header />

    <div></div>
    <div class="page-wrap">
      <v-breadcrumbs
        divider="/"
        :items="breadcrumbs"
        class="breadcrumbs"
      ></v-breadcrumbs>

      <div style="display: flex; align-items: center">
        <router-link to="/parks/UTGREA/mirabilite">
          <img src="../../../assets/images/gray-back.svg" />
        </router-link>
        <div class="dateTitle">
          <div class="dateTitle">{{ formattedDateTitle }}</div>
        </div>
      </div>
      <br />

      <div class="passContainer2">
        <div class="infoMargin">
          <!-- making the shopify buy button here -->
          <!-- Shopify product selector + buy button -->
          <div v-if="loading" class="shopifyCollectionWrap">
            Loading ticket options…
          </div>

          <div v-else-if="error" class="shopifyCollectionWrap">
            {{ error }}
          </div>

          <div v-else-if="product" class="shopifyBox">
            <img
              v-if="displayImageSrc"
              :src="displayImageSrc"
              :alt="product.title"
              class="shopifyProductImage"
            />
            <div class="passType">{{ product.title }}</div>

            <!-- Dropdowns (only show options you want dropdowns for) -->
            <div
              v-for="opt in visibleOptions"
              :key="opt.name"
              style="margin: 12px 0"
            >
              <div style="font-family: boldRoboto; margin-bottom: 6px">
                {{ opt.name }}
              </div>

              <select
                v-model="selectedOptions[opt.name]"
                @change="onOptionChange"
                style="
                  width: 100%;
                  height: 42px;
                  border-radius: 8px;
                  border: 1px solid #c4c4c4;
                  padding: 0 12px;
                "
              >
                <option
                  v-for="val in opt.values"
                  :key="typeof val === 'object' ? val.value : val"
                  :value="typeof val === 'object' ? val.value : val"
                >
                  {{ typeof val === "object" ? val.value : val }}
                </option>
              </select>
            </div>
            <!-- Participants count -->
            <div class="participantRow">
              <div class="participantLabel">Participants</div>

              <div class="participantControls">
                <button
                  class="participantBtn"
                  @click="decrementParticipants"
                  :disabled="participants <= 1"
                  type="button"
                >
                  –
                </button>

                <div class="participantCount">{{ participants }}</div>

                <button
                  class="participantBtn"
                  @click="incrementParticipants"
                  :disabled="participants >= maxParticipants"
                  type="button"
                >
                  +
                </button>
              </div>

              <div v-if="maxParticipants" class="participantHint">
                Max {{ maxParticipants }}
              </div>
            </div>
            <!-- Participant names -->
            <div v-if="participants" class="participantNames">
              <div class="participantLabel" style="margin-top: 14px">
                Participant names
              </div>

              <div v-for="n in participants" :key="n" style="margin: 10px 0">
                <input
                  v-model="participantNames[n - 1]"
                  class="participantInput"
                  type="text"
                  :placeholder="`Participant ${n} name`"
                />
              </div>
            </div>

            <div style="margin-top: 16px">
              <div v-if="selectedVariant" style="margin-bottom: 10px">
                <div style="font-family: mediumRoboto">
                  Price:
                  {{ formatMoney(totalPriceAmount, currencyCode) }}
                </div>

                <div class="green-btn" @click="submitFrom">Buy</div>
              </div>

              <div v-else class="gray-btn">Unavailable</div>
            </div>
          </div>

          <!-- end shopify buy button -->
        </div>
        <v-divider class="divider" />
        <div class="infoMargin2">
          <p class="passTitle">Event Information</p>
          <div class="passContainer">
            <img src="../../../assets/images/info.svg" />
            <div class="iconMargin">
              <div class="eventTitle">Overview</div>
              <p>
                Are you interested in visiting the Great Salt Lake State Park to
                see the Mirabilite Formations? Now is your chance to attend a
                Ranger lead tour about these formations. These salt mineral
                deposits can only be seen during specific winter conditions and
                we do not know how long these formations will last this year.
                This is a unique opportunity to walk along Silver Sands Beach
                with a Park Ranger to view and speak about the rare Mirabilite
                Formations that form during winter.
              </p>
              <br />
              <p>
                The walk will begin on the back patio of the Visitors Center.
                This event is $3 per person + the
                <router-link to="/parks/UTGREA/dayuse" class="greenLink"
                  >$10 (per vehicle) entry fee</router-link
                >. Dogs are welcome but must be on leash. This walk is expected
                to take about 45 minutes. The walk will be just under a mile on
                the beach, expect typical beach hazards during the walk.
                Waterproof Shoes required to get to Mirabilites.
              </p>
              <br />
              <p>
                If you would like to buy your day use fee ahead of time you can
                do so here:
                <router-link to="/parks/UTGREA/dayuse" class="greenLink URL"
                  >https://parkspass.utah.gov/parks/UTGREA/dayuse</router-link
                >
              </p>
            </div>
          </div>
          <div class="passContainer">
            <img src="../../../assets/images/personCheck.svg" />
            <div class="iconMargin">
              <div class="eventTitle">Tickets Available</div>
              <p>
                Everyone must pre-register, we will only have 30 people max
                capacity for each time slot. If you are not pre-registered we
                can not ensure there will be room on the tour.
              </p>
            </div>
          </div>
          <div class="passContainer">
            <img src="../../../assets/images/location.svg" />
            <div class="iconMargin">
              <div class="eventTitle">Location</div>
              <p>
                Meet on the back deck of the Visitors Center at the Great Salt
                Lake State Park (Exit 104 off of I-80). This event is not on
                Antelope Island.
              </p>
            </div>
          </div>
          <div class="passContainer">
            <img src="../../../assets/images/lantern.svg" />
            <div class="iconMargin">
              <div class="eventTitle">What to bring</div>
              <p>
                Waterproof Shoes are highly recommended for this tour,
                conditions are usually wet this time of year. Dress accordingly
                for the weather. We may even encounter some ice on the beach.
              </p>
            </div>
          </div>
          <div class="passContainer">
            <img src="../../../assets/images/Disclaimer.svg" />
            <div class="iconMargin">
              <div class="eventTitle">Disclaimer</div>
              <p>
                *This event may be canceled if the weather is snowy and blocks
                visibility of the formations.
              </p>
              <p>
                **This is event is held at the Great Salt Lake Marina in Magna,
                and NOT on Antelope Island.
              </p>
            </div>
          </div>
          <div class="passContainer">
            <img src="../../../assets/images/phone.svg" />
            <div class="iconMargin">
              <div class="eventTitle">Event Contact Info</div>
              <p>
                For more information about this event, contact the Great Salt
                Lake State Park Visitor Center at
                <a href="tel:8108280787">801-828-0787</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://evey-files.s3.amazonaws.com/js/evey_buy_button.js"></script>
<script>
import Client from "shopify-buy";
import Header from "../../../components/Header.vue";
import $ from "jquery";
export default {
  name: "MirabiliteTours",
  metaInfo: {
    title: "Mirabilite Tours",
    meta: [
      {
        name: "description",
        content: "",
      },
    ],
  },
  components: {
    Header,
  },
  data() {
    return {
      productId: "",
      breadcrumbs: [],
      date: this.$route.params.dates,

      // Shopify product state
      product: null,
      selectedOptions: {},
      selectedVariant: null,

      loading: false,
      error: "",
      checkoutUrl: "",
      participants: 1,
      maxParticipants: 5,
      participantNames: [""], // start with 1 participant input
      client: null,
      uuid: this.generateUUID(),
    };
  },
  created() {
    this.breadcrumbs = [
      { text: "Home", disabled: false, href: "/" },
      {
        text: "Great Salt Lake",
        disabled: false,
        href: "/parks/" + this.$route.params.name + "/dayuse",
      },
      {
        text: "Event",
        disabled: true,
      },
    ];
  },
  async mounted() {
    document.getElementById("header")?.scrollIntoView();

    // Map date -> Shopify product ID
    if (this.date === "January10") this.productId = "8607767134361";
    else if (this.date === "January11") this.productId = "8607767396505";
    else if (this.date === "January17") this.productId = "8607768314009";
    else if (this.date === "January18") this.productId = "8607769362585";
    else if (this.date === "January19") this.productId = "8607769821337";
    else if (this.date === "Feburary7") this.productId = "8624490381465";

    if (!this.productId) {
      this.error = "No product mapped for this date.";
      return;
    }

    await this.loadProduct();
  },
  computed: {
    formattedDateTitle() {
      // Example inputs: "January10", "Feburary7"
      const raw = String(this.date || "").trim();

      // split "January10" -> monthPart="January", dayPart="10"
      const match = raw.match(/^([A-Za-z]+)(\d{1,2})$/);
      if (!match) return raw; // fallback if param is unexpected

      let monthPart = match[1];
      const day = Number(match[2]);

      // normalize common typo(s) coming from routes
      if (monthPart.toLowerCase() === "feburary") monthPart = "February";

      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const monthIndex = months.findIndex(
        (m) => m.toLowerCase() === monthPart.toLowerCase()
      );

      if (monthIndex === -1 || !day) return raw; // fallback

      // Use your fixed year (or swap 2026 for something dynamic if you want)
      const d = new Date(2026, monthIndex, day);

      // "January 10, 2026"
      return new Intl.DateTimeFormat("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      }).format(d);
    },

    visibleOptions() {
      if (!this.product?.options) return [];
      return this.product.options.filter((o) => (o.values?.length || 0) > 1);
    },
    displayImageSrc() {
      const vImg =
        this.selectedVariant?.image?.src ||
        this.selectedVariant?.image?.originalSrc;

      const pImg =
        this.product?.images?.[0]?.src ||
        this.product?.images?.[0]?.originalSrc;

      return vImg || pImg || "";
    },
    unitPriceAmount() {
      const a =
        this.selectedVariant?.priceV2?.amount ??
        this.selectedVariant?.price?.amount ??
        this.selectedVariant?.price ??
        0;

      return Number(a || 0);
    },
    currencyCode() {
      return (
        this.selectedVariant?.priceV2?.currencyCode ??
        this.selectedVariant?.price?.currencyCode ??
        "USD"
      );
    },
    totalPriceAmount() {
      return this.unitPriceAmount * Number(this.participants || 0);
    },
  },
  methods: {
    incrementParticipants() {
      if (this.participants >= this.maxParticipants) return;
      this.participants += 1;
      this.participantNames.push("");
    },
    decrementParticipants() {
      if (this.participants <= 1) return;
      this.participants -= 1;
      this.participantNames.pop();
    },

    shopifyClient() {
      // Put these in env vars (recommended)
      const domain = "parkspassutah.myshopify.com"; // e.g. "parkspass.myshopify.com"
      const storefrontAccessToken = "a245460c3b59913598a8b8b1f049af40";

      if (!domain || !storefrontAccessToken) {
        throw new Error("Missing Shopify domain/token env vars.");
      }

      return Client.buildClient({ domain, storefrontAccessToken });
    },

    async loadProduct() {
      this.loading = true;
      this.error = "";
      this.product = null;
      this.selectedOptions = {};
      this.selectedVariant = null;
      this.checkoutUrl = "";

      try {
        const client = this.shopifyClient();
        this.client = client;

        const gid = `gid://shopify/Product/${this.productId}`;
        const product = await client.product.fetch(gid);

        if (!product) throw new Error("Product not found.");
        this.product = product;

        console.log("options", product.options);
        console.log("variants", product.variants?.length);

        // ✅ Start with FIRST VARIANT selected
        const firstVariant = product.variants?.[0];
        if (firstVariant) {
          // Build selectedOptions from the variant’s selectedOptions list
          const soList = firstVariant.selectedOptions || [];
          soList.forEach((so) => {
            if (so?.name && so?.value != null) {
              this.$set?.(this.selectedOptions, so.name, so.value) ||
                (this.selectedOptions[so.name] = so.value);
            }
          });

          // Fallback: if variant didn’t have selectedOptions for some reason,
          // at least pick the first value from each option.
          if (
            !Object.keys(this.selectedOptions).length &&
            product.options?.length
          ) {
            for (const opt of product.options) {
              const firstVal = opt.values?.[0];
              if (firstVal != null) {
                const v =
                  typeof firstVal === "object" ? firstVal.value : firstVal;
                this.$set?.(this.selectedOptions, opt.name, v) ||
                  (this.selectedOptions[opt.name] = v);
              }
            }
          }
        }

        console.log("selectedOptions after init", this.selectedOptions);

        // This will also log the initial selection via resolveSelectedVariant()
        this.resolveSelectedVariant(true);
      } catch (e) {
        console.error("Shopify loadProduct error:", e);
        this.error =
          e?.errors?.[0]?.message ||
          e?.message ||
          JSON.stringify(e) ||
          "Failed to load product.";
      } finally {
        this.loading = false;
      }
    },

    onOptionChange() {
      this.resolveSelectedVariant(false);
    },

    resolveSelectedVariant(isInitial = false) {
      if (!this.product?.variants?.length) {
        this.selectedVariant = null;
        return;
      }

      const selections = { ...this.selectedOptions };

      const match = this.product.variants.find((v) => {
        const soList = v.selectedOptions || [];
        if (!soList.length) return true;

        return soList.every((so) => {
          const selected = selections[so.name];
          if (selected == null) return false;
          return String(selected) === String(so.value);
        });
      });

      const prevId = this.selectedVariant?.id;
      this.selectedVariant = match || null;

      const nextId = this.selectedVariant?.id;

      // ✅ Console every time a NEW one is selected
      if (nextId && nextId !== prevId) {
        console.log(
          isInitial
            ? "[Shopify] initial variant selected:"
            : "[Shopify] variant changed:",
          {
            id: nextId,
            title: this.selectedVariant?.title,
            selectedOptions: this.selectedVariant?.selectedOptions,
            price:
              this.selectedVariant?.priceV2?.amount ??
              this.selectedVariant?.price,
          }
        );
      }
    },

    formatMoney(amount, currency) {
      const n = Number(amount || 0);
      try {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: currency || "USD",
        }).format(n);
      } catch {
        return `$${n.toFixed(2)}`;
      }
    },
    generateUUID() {
      // Public Domain/MIT
      let d = new Date().getTime(); //Timestamp
      let d2 =
        (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          let r = Math.random() * 16; //random number between 0 and 16
          if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
          } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
          }
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    },
    submitFrom() {
      const passId = this.uuid;
      const agreed = this.agreed; // make sure this exists in data()
      const eventDate = this.date;

      const rawVariantId = this.selectedVariant?.id || "";
      const eventVariantId = rawVariantId.split("/").pop(); // ✅ number only

      // Build ONE object per participant (length = this.participants)
      const participantData = Array.from(
        { length: this.participants },
        (_, i) => {
          const name = (this.participantNames[i] || "").trim();

          return {
            firstname: name, // or "name" depending on what your API expects
            minor: "0",
            agreed: "1",
            passId: passId,
            event: eventVariantId,
          };
        }
      );

      console.log("participantData:", participantData);
      var _this = this;

      console.log("Submitting waiver data...");
      for (let f in participantData) {
        var data = participantData[f];
        console.log("data: ", data);
        data = JSON.stringify(data);
        console.log("data: ", data);
        $.ajax({
          url: "https://trailwaze.info/waivers/addWaiver.php",
          type: "POST",
          dataType: "json",
          data: data,
          success: function (json) {
            _this.json = json;
            console.log("new json: ", _this.json);
          },
          error: function (xhr, status, error) {
            console.log("Error: " + error);
          },
        });
      }
      this.MakeShiftShopify();
    },
    MakeShiftShopify() {
      console.log("make shift shopify");
      console.log("particiapants: ", this.participantNames);
      var client = ShopifyBuy.buildClient({
        domain: "parkspassutah.myshopify.com",
        storefrontAccessToken: "a245460c3b59913598a8b8b1f049af40",
      });

      var variantId = this.selectedVariant.id; // The variant ID you want to add to the cart
      var quantity1 = this.participants;
      console.log("quantity: ", quantity1);
      console.log("variantId: ", variantId);
      if (!variantId.startsWith("gid://")) {
        variantId = `gid://shopify/ProductVariant/${variantId}`;
      }

      // Generate a UUID
      const uuid = this.uuid;

      // Create an array to hold custom attributes
      let customAttributes = [
        { key: "UUID", value: uuid },
        { key: "event_date", value: this.date },
      ];

      // Loop through AdultData and add full names as custom attributes
      // Loop through participants and add names as custom attributes
      for (let i = 0; i < this.participants; i++) {
        const fullName = (this.participantNames[i] || "").trim();

        console.log(`Participant ${i + 1}:`, fullName || "(no name)");

        customAttributes.push({
          key: `participant${i + 1}`,
          value: fullName || `Participant ${i + 1}`, // never undefined/null
        });
      }

      client.checkout
        .create({
          customAttributes: customAttributes,
        })
        .then((checkout) => {
          var lineItemsToAdd = [
            {
              variantId: variantId,
              quantity: quantity1,
            },
          ];
          return client.checkout.addLineItems(checkout.id, lineItemsToAdd);
        })
        .then((checkout) => {
          // Direct the user to the checkout
          window.location.href = checkout.webUrl;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    async goToCheckout() {
      if (!this.selectedVariant?.id) return;

      try {
        const client = this.shopifyClient();

        const checkout = await client.checkout.create();
        const lineItemsToAdd = [
          { variantId: this.selectedVariant.id, quantity: this.participants },
        ];

        const updatedCheckout = await client.checkout.addLineItems(
          checkout.id,
          lineItemsToAdd
        );

        const names = this.participantNames
          .map((x) => (x || "").trim())
          .filter(Boolean);

        const note = names.length
          ? `Participants (${names.length}):\n- ${names.join("\n- ")}`
          : `Participants: ${this.participants} (no names entered)`;

        const updatedWithNote = await client.checkout.updateAttributes(
          updatedCheckout.id,
          { note }
        );

        window.location.href = updatedWithNote.webUrl;
      } catch (e) {
        this.error = e?.message || "Checkout failed.";
      }
    },
  },
};
</script>

<style scoped>
.participantRow {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #e6e6e6;
}

.participantLabel {
  font-family: boldRoboto;
  margin-bottom: 8px;
}

.participantControls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.participantBtn {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  border: 1px solid #c4c4c4;
  background: white;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.participantBtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.participantCount {
  min-width: 48px;
  text-align: center;
  font-family: mediumRoboto;
  font-size: 18px;
}

.participantHint {
  margin-top: 6px;
  font-size: 12px;
  color: #666;
}

.v-breadcrumbs__item--disabled {
  color: rgba(0, 0, 0, 0.38);
}
p {
  line-height: 22px;
}
.shopifyCollectionWrap {
  width: 100%;
  min-height: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  border: solid 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  align-items: center;
  justify-content: center;
}
.divider {
  margin: 24px 0px;
  display: hidden;
}
.page-wrap {
  padding: 32px;
  max-width: 1600px;
  margin: 0 auto;
}
.dateTitle {
  font-size: 24px;
  font-family: "boldRoboto";
  margin-left: 12px;
  /* margin-top: 44px; */
}
.passTitle {
  font-size: 24px;
  font-family: "boldRoboto";
  margin-bottom: 12px;
  /* margin-top: 44px; */
}
.greenLink {
  color: #96a145;
  text-decoration: underline #96a145 !important;
  font-size: 16px;
  font-family: "boldRoboto";
  margin: 16px 0px;
  /* display: block; */
  cursor: pointer;
}
.eventImg {
  width: 100%;
  max-height: 350px;
  object-fit: cover;
  object-position: bottom;
  height: auto;
  position: relative;
}
.participantInput {
  width: 100%;
  height: 42px;
  border-radius: 8px;
  border: 1px solid #c4c4c4;
  padding: 0 12px;
  font-family: regularRoboto;
}

.golfImage {
  width: 330px;
  height: 198px;
  object-fit: cover;
  margin-top: 25px;
  margin-right: 25px;
  object-position: 0% 0;
}
.cloud {
  margin-right: 25px;
}
.bottom-left {
  position: absolute;
  bottom: 0px;
  width: 100%;
  max-width: 1600px;
  padding: 32px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.eventBox p,
.eventBox li,
.eventBox li a,
.eventBox a {
  font-size: 16px;
}
.eventText {
  margin: 0px;
}
.eventTitle {
  margin-top: 16px;
  margin-bottom: 4px;
  font-family: "boldRoboto";
  font-size: 18px;
}
.shopifyContainer {
  position: relative;
  width: 100%;
  /* background-color: whitesmoke; */
  display: flex;
}
.shopifyWrap,
.shopifyWrap2 {
  display: inline-block;
  height: 100%;
  /* background-color: whitesmoke; */
  border: none;
  width: 100%;
  padding: 0px;
  margin: 0px;
}
.flexWrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.flexWrapRow {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}
.shopifyFlex {
  display: flex;
  /* background-color: whitesmoke */
}
.shopifyBox,
.shopifyBox2,
.waiverBox {
  background-color: white;
  width: auto;
  border: 1px solid #c4c4c4;
  padding: 32px;
  position: relative;
  margin-left: 0px;
}
.waiverBox {
  margin-left: 32px;
}
.shopifyBox {
  margin: 0px;
  margin-bottom: 32px;
}
.shopifyBox2 {
  margin-top: 0px;
}
.shopifyBox2 a {
  font-size: 24px;
  text-decoration: underline;
  color: #96a145;
  font-family: "mediumRoboto";
  cursor: pointer;
}
.shopify-buy__product {
  padding-top: 50px;
  max-width: calc(75% - 20px) !important;
  width: calc(75% - 20px) !important;
}
.collectionDiv {
  padding: 32px 0px;
  height: 100%;
}
.eventBox p,
.eventBox li,
.eventBox li a,
.eventBox a {
  font-size: 16px;
}
.green-btn {
  height: 42px;
  line-height: 42px;
  border-radius: 32px;
  background-color: #96a145;
  color: white;
  width: 140px;
  padding: 0px 16px;
  text-align: center;
  font-size: 16px;
  font-family: "regularRoboto";
  margin-top: 8px;
  cursor: pointer;
}
.gray-btn {
  padding: 16px;
  border-radius: 32px;
  background-color: gray;
  color: white;
  width: 200px;
  text-align: center;
  font-size: 18px;
  margin-top: 16px;
  cursor: auto;
}
.green-btn:hover {
  background-color: #818a3c;
}
/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-bottom: 12px;
  margin-top: 32px;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border: 2px solid lightgray;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #96a145;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.waiverBox {
  text-align: left;
  max-width: 30%;
  align-self: baseline;
}
b {
  font-weight: bold;
}
.mobileShow {
  display: none;
}
.v-breadcrumbs ::v-deep(a) {
  color: #96a145;
}

.passType {
  font-size: 24px;
  font-family: "boldRoboto";
  color: #494e53;
  margin-top: 0px;
  padding: 4px 0px;
}
.passText {
  display: inline-block;
  font-size: 16px;
  line-height: 24px;
  margin: 0px;
}
.passContainer {
  display: flex;
  margin-bottom: 8px;
  align-items: flex-start;
}
.passContainer2 {
  display: flex;
  margin: 12px 0px;
}
.buttonContainer {
  float: right;
  display: block;
  margin: 12px 16px;
  cursor: pointer;
  height: 24px;
  margin-left: auto;
}
#signUpButton {
  background: #96a145;
  border: 1px solid #96a145;
  box-sizing: border-box;
  border-radius: 48px;
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 40px;
  font-size: 16px;
  line-height: 1.2;
  display: inline-block;
  font-weight: 1000;
}
.iconMargin {
  margin-left: 14px;
}
.passMargin {
  margin-left: 34px;
}
.infoMargin {
  width: 50vw;
  /* max-width: 50%; */
}
.infoMargin2 {
  margin-left: 34px;
  max-width: 50%;
}
.price {
  text-align: center;
  display: block;
  margin: 3px;
}
.month {
  font-size: 12px;
  color: #96a145;
  text-align: center;
  line-height: 24px;
  font-family: "boldRoboto";
  /* font-weight: 1000; */
}
.day {
  font-size: 18px;
  color: #494e53;
  text-align: center;
  line-height: 24px;
  /* font-family: 'boldRoboto'; */
  font-weight: 1000;
}
a {
  text-decoration: none;
  color: #96a145;
}
.passContainer > img {
  margin-top: 15px;
}
.v-breadcrumbs {
  padding: 18px 0px;
}
.shopifyProductImage {
  width: 100%;

  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 12px;
}
@media only screen and (max-width: 850px) {
  .passTitle {
    margin-top: 20px;
  }
  .passContainer2 {
    display: inline;
  }
  .passContainer {
    align-items: flex-start;
  }
  .passContainer > img {
    margin-top: 15px;
  }
  .passMargin {
    margin-left: 16px;
  }
  .infoMargin {
    width: 100%;
    margin-left: 0px;
  }
  .infoMargin2 {
    margin-left: 0px;
    max-width: unset;
  }
  .bottom-left {
    padding: 25px;
  }
  .page-wrap {
    padding: 16px;
  }
  .mobileShow {
    display: block;
  }
  .waiverBox {
    display: none;
  }
  .shopifyContainer {
    display: block;
    padding: 8px;
    width: auto;
  }
  .shopifyWrap,
  .shopifyBox,
  .shopifyBox2 {
    margin-left: 0px;
    margin-right: 0px;
    padding: 16px;
  }
  .shopifyWrap {
    width: -webkit-fill-available;
    margin-bottom: 8px;
    margin-top: 0px;
    padding: 0px;
  }
  .flexWrap {
    width: auto;
  }
  .shopifyFlex {
    display: block;
  }
  .waiverBox {
    max-width: 100%;
    margin: 8px;
  }
  .shopifyWrap2 {
    margin-left: 0px;
  }
  .wrapLeft {
    margin: 8px;
  }
  .collectionDiv {
    padding: 0px;
  }
  .shopifyBox,
  .shopifyBox2 {
    margin: 0px 0px;
  }
  .shopifyBox2 {
    margin-top: 8px;
  }
  .passText,
  .passType {
    font-size: 16px;
  }
  .eventInfoTitle {
    font-size: 16px;
  }
  .infoBox {
    margin-top: 8px !important;
  }
  .eventBox p,
  .eventBox li,
  .eventBox li a,
  .eventBox a {
    font-size: 14px;
  }
  .eventInfoTitle {
    font-size: 22px;
    font-family: "boldRoboto";
  }
  .eventImg {
    /* filter: brightness(80%); */
    object-position: top;
    height: 350px;
  }

  .shopifyCollectionWrap {
    border: none;
  }
}
@media only screen and (max-width: 425px) {
  .iconMargin {
    width: 300px;
  }
}
@media only screen and (max-width: 375px) {
  .URL {
    font-size: 12px;
  }
}
@media only screen and (max-width: 320px) {
  .iconMargin {
    width: 250px;
  }
  .URL {
    font-size: 10px;
  }
}
</style>
